import { DeleteConfigurationSourceData } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import ConfigurationSourceDataConfigurationList from "@/components/lists/status/ConfigurationSourceDataConfigurationList";
import ServiceStackClientContext from "@/contexts/api/ServiceStackClientContext";
import TrialContext from "@/contexts/data/TrialContext";
import { ConfigurationSourceDatasTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useConfigurationSourceDatas from "@/hooks/data/useConfigurationSourceDatas";
import { Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { FC, useCallback, useContext } from "react";

const ConfigurationSourceDatas: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: sourceDatas, loading: sourceDatasLoading, validating: sourceDatasValidating, refresh: sourceDataRefresh } = useConfigurationSourceDatas(trial?.id ? {trialId: trial.id, isGlobal: false} : undefined);

    const client = useContext(ServiceStackClientContext);

    const { enqueueSnackbar } = useSnackbar()


    const deleteConfiguration = useCallback(async (configurationSourceDataId?: number) => {
        try {
            await client.delete(new DeleteConfigurationSourceData({ configurationSourceDataId }));

            await sourceDataRefresh();
            
            enqueueSnackbar(`Configuration successfully deleted!`, { variant: "success" });

            return true;
        }
        catch {
            enqueueSnackbar(`An error occurred while attempting to delete the configuration!`, { variant: "error" });

            return false;
        }
    }, [sourceDataRefresh, client]);

    const loading = sourceDatasLoading;
    const validating = sourceDatasValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationSourceDatasTrialCreateLink} 
                institutionLinkEnabled={false} 
                participantLinkEnabled={false} 
            />
            <IsLoading name="configuration-source-datas-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; Source Data
                </Typography>
                <ConfigurationSourceDataConfigurationList
                    data={sourceDatas}
                    deleteConfiguration={deleteConfiguration}
                />
            </Show>
        </>
    )
};

export default ConfigurationSourceDatas;